import { useServicesContext } from "@modules/core/services/services.context"
import { ExploreContentEntity } from "@modules/explore/entities/exploreEntity"
import { ExploreFilter } from "@modules/explore/exploreTypes"
import { useInfiniteQuery } from "@tanstack/react-query"
import { useMemo } from "react"

export const useExploreSearchContents = (filter: ExploreFilter, searchTerms?: string) => {
  const { exploreApi } = useServicesContext()

  const { data, isLoading, refetch, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
    queryKey: ["exploreSearch", searchTerms, filter],
    queryFn: async ({ pageParam }) => {
      return await exploreApi.searchExplore(searchTerms, {
        filter: filter === ExploreFilter.DEFAULT ? undefined : filter,
        page: pageParam,
        size: 39,
      })
    },
    staleTime: 1000 * 60 * 5,
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      if (lastPage.page >= lastPage.totalPages - 1) {
        return undefined
      }
      return lastPage.page + 1
    },
  })

  const itemList = useMemo(
    () => data?.pages.flatMap((page) => page.content).map((content) => ExploreContentEntity.fromDto(content)) ?? [],
    [data],
  )

  return {
    data: {
      ...data,
      content: itemList,
      totalSize: data?.pages[0]?.totalSize ?? 0,
    },
    isLoading,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  }
}
